var _toConsumableArray = require("/codebuild/output/src4110488206/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/codebuild/output/src4110488206/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _defineProperty = require("/codebuild/output/src4110488206/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var $6g9id$qs = require("qs");
var $6g9id$lodash = require("lodash");
var $6g9id$sparkpostdesigntokens = require("@sparkpost/design-tokens");
var $6g9id$datefns = require("date-fns");
var $6g9id$moment = require("moment");
var $6g9id$datefnstz = require("date-fns-tz");
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function (key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }
    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });
  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $76c5e6d5f2354573$exports = {};
$parcel$export($76c5e6d5f2354573$exports, "calculateMetrics", function () {
  return $76c5e6d5f2354573$export$89c02dd9c4da38aa;
});
function $76c5e6d5f2354573$export$89c02dd9c4da38aa(data, metrics) {
  return data.map(function (dataPoint) {
    return metrics.reduce(function (acc, metric) {
      if (metric.compute) acc[metric.key] = metric.compute(acc, metric.computeKeys) || 0;
      return acc;
    }, dataPoint);
  });
}
var $7cdedcf0446b0cfd$exports = {};
$parcel$export($7cdedcf0446b0cfd$exports, "dehydrateFilters", function () {
  return $7cdedcf0446b0cfd$export$caba4a301a9efc9e;
});
function $7cdedcf0446b0cfd$export$caba4a301a9efc9e(groupings) {
  return groupings.map(function (grouping) {
    var groupingKeys = Object.keys(grouping);
    var groupingType = groupingKeys[0];
    var filters = Object.keys(grouping[groupingType]);
    return _defineProperty({}, groupingType, filters.reduce(function (ret, filter1) {
      var filterObj = grouping[groupingType][filter1];
      var comparisons = Object.keys(filterObj);
      ret[filter1] = comparisons.reduce(function (filterRet, comparison) {
        switch (comparison) {
          case "eq":
          case "notEq":
            if (filter1 === "subaccounts") filterRet[comparison] = filterObj[comparison].map(function (subaccount) {
              return typeof subaccount === "string" ? subaccount : String(subaccount.id);
            });else filterRet[comparison] = filterObj[comparison].map(function (filter) {
              return typeof filter === "string" ? filter : filter.value;
            });
            return filterRet;
          case "like":
          case "notLike":
          default:
            filterRet[comparison] = filterObj[comparison];
            return filterRet;
        }
      }, {});
      return ret;
    }, {}));
  });
}
var $dfd4d1c1e3b52230$exports = {};
$parcel$export($dfd4d1c1e3b52230$exports, "getAPIParamsFromUIQuery", function () {
  return $dfd4d1c1e3b52230$export$20afc3e1fe7bfc7b;
});
var $5d9b09857b8fa08e$exports = {};
$parcel$export($5d9b09857b8fa08e$exports, "HIBANA_METRICS_COLORS", function () {
  return $5d9b09857b8fa08e$export$c3f418cdae11e815;
});
$parcel$export($5d9b09857b8fa08e$exports, "categories", function () {
  return $5d9b09857b8fa08e$export$2c76aca27257bcfa;
});
$parcel$export($5d9b09857b8fa08e$exports, "REPORT_BUILDER_FILTER_KEY_MAP", function () {
  return $5d9b09857b8fa08e$export$e143335c1543628;
});
$parcel$export($5d9b09857b8fa08e$exports, "REPORT_BUILDER_FILTER_KEY_INVERTED_MAP", function () {
  return $5d9b09857b8fa08e$export$938bb5fdbf904224;
});
$parcel$export($5d9b09857b8fa08e$exports, "PREFETCHED_KEY", function () {
  return $5d9b09857b8fa08e$export$3a28e3a2b7e54f6;
});
$parcel$export($5d9b09857b8fa08e$exports, "NON_PREFETCHED_KEY", function () {
  return $5d9b09857b8fa08e$export$b62ef4c67ed4b184;
});
$parcel$export($5d9b09857b8fa08e$exports, "nonPrefetchedMetrics", function () {
  return $5d9b09857b8fa08e$export$d334702e3b05c761;
});
$parcel$export($5d9b09857b8fa08e$exports, "list", function () {
  return $5d9b09857b8fa08e$export$8837f4fc672e936d;
});
$parcel$export($5d9b09857b8fa08e$exports, "deliverabilityList", function () {
  return $5d9b09857b8fa08e$export$e02e63fda0b3a81c;
});
$parcel$export($5d9b09857b8fa08e$exports, "bounceTabMetrics", function () {
  return $5d9b09857b8fa08e$export$13acb3da2d2f7436;
});
$parcel$export($5d9b09857b8fa08e$exports, "rejectionTabMetrics", function () {
  return $5d9b09857b8fa08e$export$f50be4e64d945ebd;
});
$parcel$export($5d9b09857b8fa08e$exports, "delayTabMetrics", function () {
  return $5d9b09857b8fa08e$export$dce03f1dce1dbb81;
});
$parcel$export($5d9b09857b8fa08e$exports, "linksTabMetrics", function () {
  return $5d9b09857b8fa08e$export$20e66e155200ce;
});
$parcel$export($5d9b09857b8fa08e$exports, "DELIVERABILITY_BOUNCE_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$93a3932e55e08b73;
});
$parcel$export($5d9b09857b8fa08e$exports, "DELIVERABILITY_DELAY_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$3153a1856b13a66c;
});
$parcel$export($5d9b09857b8fa08e$exports, "DELIVERABILITY_REJECTION_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$d83bf8754cc127f4;
});
$parcel$export($5d9b09857b8fa08e$exports, "DELIVERABILITY_LINKS_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$88586c7bba3bcfca;
});
$parcel$export($5d9b09857b8fa08e$exports, "LINKS_BY_DOMAIN_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$dfab43b0ae5b287f;
});
$parcel$export($5d9b09857b8fa08e$exports, "REJECTIONS_BY_DOMAIN_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$3b5f7e0951e03e2d;
});
$parcel$export($5d9b09857b8fa08e$exports, "BOUNCE_BY_DOMAIN_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$56c8589eebb696c7;
});
$parcel$export($5d9b09857b8fa08e$exports, "map", function () {
  return $5d9b09857b8fa08e$export$871de8747c9eaa88;
});
$parcel$export($5d9b09857b8fa08e$exports, "categorizedMetricsList", function () {
  return $5d9b09857b8fa08e$export$24fdeceee7dce9f;
});
$parcel$export($5d9b09857b8fa08e$exports, "INDUSTRY_BENCHMARK_METRICS_MAP", function () {
  return $5d9b09857b8fa08e$export$316876556a26de9d;
});
$parcel$export($5d9b09857b8fa08e$exports, "METRICS_UNIT_CONFIG", function () {
  return $5d9b09857b8fa08e$export$224b14d28c9ae256;
});
var $06d2d9de361ad358$exports = {};
var $bf39c630334f29ae$exports = {};
$parcel$export($bf39c630334f29ae$exports, "cumulativeSum", function () {
  return $bf39c630334f29ae$export$9e57366c37a5642e;
});
function $bf39c630334f29ae$export$9e57366c37a5642e(_ref2) {
  var data1 = _ref2.data,
    key = _ref2.key;
  var results = data1.reduce(function (cumulativeDataSet, data) {
    var cumulativeData = _objectSpread({}, data);
    if (cumulativeDataSet.length > 0) cumulativeData[key] = data[key] + cumulativeDataSet[cumulativeDataSet.length - 1][key];
    cumulativeDataSet = [].concat(_toConsumableArray(cumulativeDataSet), [cumulativeData]);
    return cumulativeDataSet;
  }, []);
  return results;
}
var $efc110279246c456$exports = {};
$parcel$export($efc110279246c456$exports, "average", function () {
  return $efc110279246c456$export$cc6710ee5f037d57;
});
var $520fb4ec03cd9501$exports = {};
$parcel$export($520fb4ec03cd9501$exports, "safeDivide", function () {
  return $520fb4ec03cd9501$export$277aabc710d9a0ad;
});
function $520fb4ec03cd9501$export$277aabc710d9a0ad(numerator, denominator) {
  var value = numerator / denominator;
  return isFinite(value) ? value : 0;
}
function $efc110279246c456$export$cc6710ee5f037d57(item) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return $520fb4ec03cd9501$export$277aabc710d9a0ad(item[keys[0]], item[keys[1]]);
}
var $237709e97774e5de$exports = {};
$parcel$export($237709e97774e5de$exports, "rate", function () {
  return $237709e97774e5de$export$e8435ed7e8ba58fa;
});
var $8850a3df4d77aa80$exports = {};
$parcel$export($8850a3df4d77aa80$exports, "divide", function () {
  return $8850a3df4d77aa80$export$cd007d971a5a2143;
});
function $8850a3df4d77aa80$export$cd007d971a5a2143(numerator, denominator) {
  if (!denominator) return NaN; //Represents invalid value;
  return numerator / denominator;
}
function $237709e97774e5de$export$e8435ed7e8ba58fa(item) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return $8850a3df4d77aa80$export$cd007d971a5a2143(item[keys[0]], item[keys[1]]);
}
$parcel$exportWildcard($06d2d9de361ad358$exports, $bf39c630334f29ae$exports);
$parcel$exportWildcard($06d2d9de361ad358$exports, $efc110279246c456$exports);
$parcel$exportWildcard($06d2d9de361ad358$exports, $237709e97774e5de$exports);
$parcel$exportWildcard($06d2d9de361ad358$exports, $520fb4ec03cd9501$exports);
$parcel$exportWildcard($06d2d9de361ad358$exports, $8850a3df4d77aa80$exports);
var $f1d7ffdf435118bb$exports = {};
var $2b426f67b59e8726$exports = {};
$parcel$export($2b426f67b59e8726$exports, "formatBytes", function () {
  return $2b426f67b59e8726$export$e1a3971de07c83b5;
});
var $b7f4fcabf3442813$exports = {};
$parcel$export($b7f4fcabf3442813$exports, "roundToPlaces", function () {
  return $b7f4fcabf3442813$export$e5391d7b13fe3535;
});
function $b7f4fcabf3442813$export$e5391d7b13fe3535(number, places) {
  var multiplier = Math.pow(10, places);
  return Math.round(number * multiplier) / multiplier;
}
var $ac7bd25d01e28e2d$exports = {};
$parcel$export($ac7bd25d01e28e2d$exports, "isNumber", function () {
  return $ac7bd25d01e28e2d$export$7e4aa119212bc614;
});
var $ac7bd25d01e28e2d$export$7e4aa119212bc614 = function $ac7bd25d01e28e2d$export$7e4aa119212bc614(value) {
  return isNaN(parseFloat(value)) === false || isFinite(value) === true;
};
var $2b426f67b59e8726$export$e1a3971de07c83b5 = $parcel$interopDefault($6g9id$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // Default case is Bytes
  var formatted = value;
  var suffix = 'B';
  var formatters = {
    PB: Math.pow(2, 50),
    TB: Math.pow(2, 40),
    GB: Math.pow(2, 30),
    MB: Math.pow(2, 20),
    KB: Math.pow(2, 10)
  };
  $parcel$interopDefault($6g9id$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString(undefined, {
    maximumSignificantDigits: 4
  })).concat(suffix);
});
var $c66c7baffc1c0dfc$exports = {};
$parcel$export($c66c7baffc1c0dfc$exports, "formatMilliseconds", function () {
  return $c66c7baffc1c0dfc$export$5daf09ba04077ce8;
});
var $c66c7baffc1c0dfc$export$5daf09ba04077ce8 = $parcel$interopDefault($6g9id$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // Default case is milliseconds
  var formatted = value;
  var suffix = 'ms';
  var formatters = {
    h: 3600000,
    m: 60000,
    s: 1000
  };
  $parcel$interopDefault($6g9id$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString()).concat(suffix);
});
var $2cb2128e0b9e1f2c$exports = {};
$parcel$export($2cb2128e0b9e1f2c$exports, "formatNumber", function () {
  return $2cb2128e0b9e1f2c$export$f5dd818bff069720;
});
var $2cb2128e0b9e1f2c$export$f5dd818bff069720 = $parcel$interopDefault($6g9id$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // No suffix for default case
  var formatted = value;
  var suffix = '';
  var formatters = {
    B: Math.pow(10, 9),
    M: Math.pow(10, 6),
    K: 1000
  };
  $parcel$interopDefault($6g9id$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString()).concat(suffix);
});
var $0a59e1cff196aa1f$exports = {};
$parcel$export($0a59e1cff196aa1f$exports, "formatYAxisPercent", function () {
  return $0a59e1cff196aa1f$export$f46f3370c2c30550;
});
var $0a59e1cff196aa1f$export$f46f3370c2c30550 = $parcel$interopDefault($6g9id$lodash).memoize(function (v) {
  if (typeof v === 'string') return v;
  if (isNaN(v)) return '---';
  v *= 100;
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(v, v < 1 ? 3 : 1), "%");
});
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $2b426f67b59e8726$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $c66c7baffc1c0dfc$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $2cb2128e0b9e1f2c$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $0a59e1cff196aa1f$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $ac7bd25d01e28e2d$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $b7f4fcabf3442813$exports);
var $5d9b09857b8fa08e$export$c3f418cdae11e815 = [$6g9id$sparkpostdesigntokens.tokens.color_blue_700, $6g9id$sparkpostdesigntokens.tokens.color_teal_600, $6g9id$sparkpostdesigntokens.tokens.color_purple_800, $6g9id$sparkpostdesigntokens.tokens.color_magenta_600, $6g9id$sparkpostdesigntokens.tokens.color_blue_900, $6g9id$sparkpostdesigntokens.tokens.color_yellow_500, $6g9id$sparkpostdesigntokens.tokens.color_gray_700, $6g9id$sparkpostdesigntokens.tokens.color_purple_500, $6g9id$sparkpostdesigntokens.tokens.color_gray_1000];
var $5d9b09857b8fa08e$var$injection = 'Injection';
var $5d9b09857b8fa08e$var$delivery = 'Delivery';
var $5d9b09857b8fa08e$var$deliverability = 'Deliverability';
var $5d9b09857b8fa08e$var$engagement = 'Engagement';
var $5d9b09857b8fa08e$export$2c76aca27257bcfa = [$5d9b09857b8fa08e$var$injection, $5d9b09857b8fa08e$var$delivery, $5d9b09857b8fa08e$var$deliverability, $5d9b09857b8fa08e$var$engagement];
var $5d9b09857b8fa08e$export$e143335c1543628 = {
  'Recipient Domain': 'domains',
  Campaign: 'campaigns',
  'Campaign (ID)': 'campaigns',
  'Campaign (Subject Line)': 'subject_campaigns',
  Template: 'templates',
  'Sending IP': 'sending_ips',
  'IP Pool': 'ip_pools',
  Subaccount: 'subaccounts',
  'Sending Domain': 'sending_domains',
  'Mailbox Provider': 'mailbox_providers',
  'Mailbox Provider Region': 'mailbox_provider_regions'
};
var $5d9b09857b8fa08e$export$938bb5fdbf904224 = $6g9id$lodash.invert($5d9b09857b8fa08e$export$e143335c1543628);
var $5d9b09857b8fa08e$export$3a28e3a2b7e54f6 = 'prefetchedKey';
var $5d9b09857b8fa08e$export$b62ef4c67ed4b184 = 'nonPrefetchedKey';
var $5d9b09857b8fa08e$export$d334702e3b05c761 = [_defineProperty({
  key: 'count_nonprefetched_rendered',
  label: 'Opens (Bottom Pixel)',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times the bottom open tracking pixel was rendered.',
  inSummary: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_rendered'), _defineProperty({
  key: 'count_nonprefetched_unique_rendered',
  label: 'Unique Rendered',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Total number of messages that were rendered at least once.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  deprecated: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_unique_rendered'), _defineProperty({
  key: 'count_nonprefetched_initial_rendered',
  label: 'Opens (Top Pixel)',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times the top open tracking pixel was rendered.',
  inSummary: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_initial_rendered'), _defineProperty({
  key: 'count_nonprefetched_unique_initial_rendered',
  label: 'Initial Unique Rendered',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Total number of messages that were initially rendered at least once.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  deprecated: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_unique_initial_rendered'), _defineProperty({
  key: 'count_nonprefetched_unique_confirmed_opened',
  label: 'Unique Confirmed Opens',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true,
  isUniquePerTimePeriod: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_unique_confirmed_opened'), _defineProperty({
  key: 'nonprefetched_open_rate',
  label: 'Open Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_nonprefetched_unique_confirmed_opened', 'count_unique_confirmed_opened', 'count_accepted'],
  compute: function compute(_ref8) {
    var count_nonprefetched_unique_confirmed_opened = _ref8.count_nonprefetched_unique_confirmed_opened,
      count_unique_confirmed_opened = _ref8.count_unique_confirmed_opened,
      count_accepted = _ref8.count_accepted;
    var nonprefetched_opens = count_nonprefetched_unique_confirmed_opened;
    var nonprefetched_accepted = count_accepted - (count_unique_confirmed_opened - count_nonprefetched_unique_confirmed_opened);
    return $237709e97774e5de$export$e8435ed7e8ba58fa({
      nonprefetched_opens: nonprefetched_opens,
      nonprefetched_accepted: nonprefetched_accepted
    }, ['nonprefetched_opens', 'nonprefetched_accepted']);
  },
  description: 'Percentage of Accepted emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'open_rate')];
var $5d9b09857b8fa08e$export$8837f4fc672e936d = [{
  key: 'count_targeted',
  label: 'Targeted',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails requested or relayed to SparkPost. Includes Injected and Rejected.',
  inSummary: true
}, {
  key: 'count_injected',
  label: 'Injected',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails successfully generated or relayed through SparkPost.',
  inSummary: true
}, {
  key: 'count_sent',
  label: 'Sent',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails that were attempted to be delivered. Includes Deliveries and Bounces.',
  inSummary: true
}, {
  key: 'count_accepted',
  label: 'Accepted',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: "Number of emails delivered that didn't subsequently bounce (Out-of-Band).",
  inSummary: true
}, {
  key: 'count_delivered_first',
  label: 'Delivered 1st Attempt',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails delivered on the first attempt.',
  inSummary: true
}, {
  key: 'count_delivered_subsequent',
  label: 'Delivered 2+ Attempts',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails delivered that required more than one attempt.',
  inSummary: true
}, {
  key: 'count_spam_complaint',
  label: 'Spam Complaints',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of spam complaints received from mailbox providers.',
  notApplicableFor: ['nodes'],
  inSummary: true
}, {
  key: 'spam_complaint_rate',
  label: 'Spam Complaint Rate',
  unit: 'percent',
  category: $5d9b09857b8fa08e$var$engagement,
  computeKeys: ['count_spam_complaint', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Spam Complaints.',
  inSummary: true
}, _defineProperty({
  key: 'count_rendered',
  label: 'Opens (Bottom Pixel)',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times the bottom open tracking pixel was rendered.',
  inSummary: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_rendered'), _defineProperty({
  key: 'count_unique_rendered',
  label: 'Unique Rendered',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Total number of messages that were rendered at least once.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  deprecated: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_unique_rendered'), _defineProperty({
  key: 'count_initial_rendered',
  label: 'Opens (Top Pixel)',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times the top open tracking pixel was rendered.',
  inSummary: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_initial_rendered'), _defineProperty({
  key: 'count_unique_initial_rendered',
  label: 'Initial Unique Rendered',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Total number of messages that were initially rendered at least once.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  deprecated: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_unique_initial_rendered'), _defineProperty({
  key: 'count_unique_confirmed_opened',
  label: 'Unique Confirmed Opens',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true,
  isUniquePerTimePeriod: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_unique_confirmed_opened'), {
  key: 'count_clicked',
  label: 'Clicks',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times that links were clicked across all emails.',
  inSummary: true,
  tab: 'links'
}, {
  key: 'count_unique_clicked',
  label: 'Unique Clicks',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of emails that had at least one link clicked.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  tab: 'links'
}, {
  key: 'count_bounce',
  label: 'Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of bounced emails, not including Admin Bounces. Includes all In-Band and Out-of-Band Bounces.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_hard_bounce',
  label: 'Hard Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails that bounced due to permanent delivery issues.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_soft_bounce',
  label: 'Soft Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails that bounced due to temporary delivery issues.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_block_bounce',
  label: 'Block Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Total number of Bounced messages due to an IP block.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_admin_bounce',
  label: 'Admin Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that were bounced by SparkPost. Not counted in Bounces.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_undetermined_bounce',
  label: 'Undetermined Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails that bounced due to undetermined reasons.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_rejected',
  label: 'Rejected',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that were rejected by SparkPost. Includes Policy Rejections, Generation Rejections, Generation Failures.',
  inSummary: true,
  tab: 'rejection'
}, {
  key: 'count_policy_rejection',
  label: 'Policy Rejections',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that were rejected by SparkPost due to policy reasons.',
  inSummary: true,
  tab: 'rejection'
}, {
  key: 'count_generation_failed',
  label: 'Generation Failures',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that failed generation due to technical reasons.',
  inSummary: true,
  tab: 'rejection'
}, {
  key: 'count_unsubscribe',
  label: 'Unsubscribes',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times a recipient clicked a tagged unsubscribe link or used the list unsubscribe header.',
  inSummary: true
}, {
  key: 'count_generation_rejection',
  label: 'Generation Rejections',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that failed generation due to policy reasons.',
  inSummary: true,
  tab: 'rejection'
}, {
  //TODO: Remove once deliverability metrics are released
  key: 'accepted_rate',
  label: 'Accepted Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_accepted', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent messages that were accepted.',
  inSummary: true
}, _defineProperty({
  key: 'open_rate',
  label: 'Open Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_unique_confirmed_opened', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Accepted emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'nonprefetched_open_rate'), {
  key: 'prefetched_open_rate',
  label: 'Open Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_unique_confirmed_opened', 'count_accepted', 'count_nonprefetched_unique_confirmed_opened'],
  compute: function compute(_ref16) {
    var count_nonprefetched_unique_confirmed_opened = _ref16.count_nonprefetched_unique_confirmed_opened,
      count_unique_confirmed_opened = _ref16.count_unique_confirmed_opened,
      count_accepted = _ref16.count_accepted;
    var nonprefetched_opens = count_nonprefetched_unique_confirmed_opened;
    var nonprefetched_accepted = count_accepted - (count_unique_confirmed_opened - count_nonprefetched_unique_confirmed_opened);
    return $237709e97774e5de$export$e8435ed7e8ba58fa({
      nonprefetched_opens: nonprefetched_opens,
      nonprefetched_accepted: nonprefetched_accepted
    }, ['nonprefetched_opens', 'nonprefetched_accepted']);
  },
  description: 'Percentage of Accepted emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true
}, {
  key: 'click_through_rate',
  label: 'Click-through Rate',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_unique_clicked', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Accepted emails that had at least one link selected.',
  inSummary: true,
  tab: 'links'
}, {
  key: 'bounce_rate',
  label: 'Bounce Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent messages that Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'hard_bounce_rate',
  label: 'Hard Bounce Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_hard_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent emails that Hard Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'soft_bounce_rate',
  label: 'Soft Bounce Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_soft_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent emails that Soft Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'block_bounce_rate',
  label: 'Block Bounce Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_block_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent messages that Block Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'admin_bounce_rate',
  label: 'Admin Bounce Rate',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'percent',
  computeKeys: ['count_admin_bounce', 'count_targeted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Targeted messages that Admin Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'undetermined_bounce_rate',
  label: 'Undetermined Bounce Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_undetermined_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent emails that Undetermined Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'unsubscribe_rate',
  label: 'Unsubscribe Rate',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_unsubscribe', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Accepted emails that resulted in unsubscribes.',
  inSummary: true
}, {
  key: 'count_delayed',
  label: 'Delayed',
  category: $5d9b09857b8fa08e$var$delivery,
  type: 'total',
  unit: 'number',
  description: "Number of emails that were temporarily rejected by a recipient's mailbox provider.",
  inSummary: true,
  tab: 'delayed'
}, {
  key: 'delayed_rate',
  label: 'Delayed Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_delayed_first', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Accepted emails that were delayed on the first delivery attempt.',
  inAnalyticsReport: true,
  tab: 'delayed'
}, {
  key: 'rejected_rate',
  label: 'Rejection Rate',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'percent',
  computeKeys: ['count_rejected', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Targeted emails that were rejected.',
  inAnalyticsReport: true,
  tab: 'rejection'
}, {
  key: 'count_delayed_first',
  label: 'Delayed 1st Attempt',
  category: $5d9b09857b8fa08e$var$delivery,
  type: 'total',
  unit: 'number',
  description: 'Number of emails that were delayed on 1st delivery attempt.',
  inSummary: true,
  tab: 'delayed'
}, {
  key: 'avg_delivery_time_first',
  label: 'Avg Latency 1st Attempt',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'milliseconds',
  computeKeys: ['total_delivery_time_first', 'count_delivered_first'],
  compute: $efc110279246c456$export$cc6710ee5f037d57,
  description: 'Average delivery time in milliseconds (latency) for emails delivered on the first attempt.',
  inSummary: true
}, {
  key: 'avg_delivery_time_subsequent',
  label: 'Avg Latency 2+ Attempts',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'milliseconds',
  computeKeys: ['total_delivery_time_subsequent', 'count_delivered_subsequent'],
  compute: $efc110279246c456$export$cc6710ee5f037d57,
  description: 'Average delivery time in milliseconds (latency) for emails delivered that required more than one attempt.',
  inSummary: true
}, {
  key: 'avg_msg_size',
  label: 'Avg Delivery Message Size',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'bytes',
  computeKeys: ['total_msg_volume', 'count_delivered'],
  compute: $efc110279246c456$export$cc6710ee5f037d57,
  description: 'Average size of delivered emails, including attachments, in bytes.',
  inSummary: true
}, {
  key: 'total_msg_volume',
  label: 'Delivery Message Volume',
  category: $5d9b09857b8fa08e$var$delivery,
  type: 'total',
  unit: 'bytes',
  description: 'Total size of delivered emails including attachments, in bytes.',
  inSummary: true
}, /* below are metrics that never show in the summary report, but are needed when making API calls from the Metrics service */{
  key: 'count_inband_bounce',
  label: 'In-band Bounces',
  type: 'total',
  unit: 'number',
  description: 'Number of emails that bounced on delivery attempt.',
  category: $5d9b09857b8fa08e$var$delivery,
  inAnalyticsReport: true,
  tab: 'bounce'
}, {
  key: 'count_outofband_bounce',
  label: 'Out-of-band Bounces',
  type: 'total',
  unit: 'number',
  description: 'Number of emails that bounced subsequent to a successful delivery.',
  category: $5d9b09857b8fa08e$var$delivery,
  inAnalyticsReport: true,
  tab: 'bounce'
}, {
  key: 'count_raw_clicked',
  type: 'total',
  unit: 'number',
  description: 'Total number of messages which had at least one link selected one or more times.'
}, {
  key: 'count_inbox',
  label: 'Inbox Folder Count',
  type: 'total',
  unit: 'number',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref17) {
    var count_inbox_panel = _ref17.count_inbox_panel,
      count_inbox_seed = _ref17.count_inbox_seed;
    return count_inbox_panel + count_inbox_seed;
  },
  computeKeys: ['count_inbox_panel', 'count_inbox_seed'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Number of seed and panel messages delivered to the inbox.'
}, {
  key: 'count_spam',
  label: 'Spam Folder Count',
  type: 'total',
  unit: 'number',
  compute: function compute(_ref18) {
    var count_spam_panel = _ref18.count_spam_panel,
      count_spam_seed = _ref18.count_spam_seed;
    return count_spam_panel + count_spam_seed;
  },
  computeKeys: ['count_spam_panel', 'count_spam_seed'],
  category: $5d9b09857b8fa08e$var$deliverability,
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Number of seed and panel messages delivered to the spam folder.'
}, {
  key: 'inbox_folder_rate',
  label: 'Inbox Folder Rate',
  unit: 'percent',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref19) {
    var count_inbox_panel = _ref19.count_inbox_panel,
      count_inbox_seed = _ref19.count_inbox_seed,
      count_spam_panel = _ref19.count_spam_panel,
      count_spam_seed = _ref19.count_spam_seed;
    return $8850a3df4d77aa80$export$cd007d971a5a2143(count_inbox_panel + count_inbox_seed, count_inbox_panel + count_inbox_seed + count_spam_panel + count_spam_seed);
  },
  computeKeys: ['count_inbox_panel', 'count_inbox_seed', 'count_spam_panel', 'count_spam_seed'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Percentage of seed and panel messages delivered to the inbox.'
}, {
  key: 'spam_folder_rate',
  label: 'Spam Folder Rate',
  unit: 'percent',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref20) {
    var count_inbox_panel = _ref20.count_inbox_panel,
      count_inbox_seed = _ref20.count_inbox_seed,
      count_spam_panel = _ref20.count_spam_panel,
      count_spam_seed = _ref20.count_spam_seed;
    return $8850a3df4d77aa80$export$cd007d971a5a2143(count_spam_panel + count_spam_seed, count_inbox_panel + count_inbox_seed + count_spam_panel + count_spam_seed);
  },
  computeKeys: ['count_inbox_panel', 'count_inbox_seed', 'count_spam_panel', 'count_spam_seed'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Percentage of seed and panel messages delivered to the spam folder.'
}, {
  key: 'count_moved_to_inbox',
  label: 'Moved to Inbox Count',
  type: 'total',
  unit: 'number',
  category: $5d9b09857b8fa08e$var$deliverability,
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Number of panel messages delivered to the spam folder but then moved to the inbox.'
}, {
  key: 'count_moved_to_spam',
  label: 'Moved to Spam Count',
  type: 'total',
  unit: 'number',
  category: $5d9b09857b8fa08e$var$deliverability,
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Number of panel messages delivered to the inbox but then moved to the spam folder.'
}, {
  key: 'moved_to_inbox_rate',
  label: 'Moved to Inbox Rate',
  unit: 'percent',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref21) {
    var count_moved_to_inbox = _ref21.count_moved_to_inbox,
      count_spam_panel = _ref21.count_spam_panel;
    return $8850a3df4d77aa80$export$cd007d971a5a2143(count_moved_to_inbox, count_spam_panel);
  },
  computeKeys: ['count_moved_to_inbox', 'count_spam_panel'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Percentage of panel messages delivered to the spam folder but then moved to the inbox.'
}, {
  key: 'moved_to_spam_rate',
  label: 'Moved to Spam Rate',
  unit: 'percent',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref22) {
    var count_moved_to_spam = _ref22.count_moved_to_spam,
      count_inbox_panel = _ref22.count_inbox_panel;
    return $8850a3df4d77aa80$export$cd007d971a5a2143(count_moved_to_spam, count_inbox_panel);
  },
  computeKeys: ['count_moved_to_spam', 'count_inbox_panel'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Percentage of panel messages delivered to the inbox but then moved to the spam folder.'
}];
var $5d9b09857b8fa08e$export$e02e63fda0b3a81c = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (metric) {
  return metric.product === 'deliverability';
});
var $5d9b09857b8fa08e$export$13acb3da2d2f7436 = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (_ref23) {
  var tab = _ref23.tab;
  return tab && tab === 'bounce';
});
var $5d9b09857b8fa08e$export$f50be4e64d945ebd = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (_ref24) {
  var tab = _ref24.tab;
  return tab && tab === 'rejection';
});
var $5d9b09857b8fa08e$export$dce03f1dce1dbb81 = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (_ref25) {
  var tab = _ref25.tab;
  return tab && tab === 'delayed';
});
var $5d9b09857b8fa08e$export$20e66e155200ce = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (_ref26) {
  var tab = _ref26.tab;
  return tab && tab === 'links';
});
var $5d9b09857b8fa08e$export$93a3932e55e08b73 = ['count_sent', 'count_bounce', 'count_inband_bounce', 'count_outofband_bounce', 'count_admin_bounce', 'count_targeted'];
var $5d9b09857b8fa08e$export$3153a1856b13a66c = ['count_accepted', 'count_delayed', 'count_delayed_first'];
var $5d9b09857b8fa08e$export$d83bf8754cc127f4 = ['count_rejected', 'count_targeted'];
var $5d9b09857b8fa08e$export$88586c7bba3bcfca = ['count_accepted', 'count_clicked', 'count_sent', 'count_unique_clicked', 'count_unique_confirmed_opened'];
var $5d9b09857b8fa08e$export$dfab43b0ae5b287f = ['count_clicked', 'count_raw_clicked'];
var $5d9b09857b8fa08e$export$3b5f7e0951e03e2d = ['count_clicked', 'count_raw_clicked'];
var $5d9b09857b8fa08e$export$56c8589eebb696c7 = ['count_bounce'];
var $5d9b09857b8fa08e$export$871de8747c9eaa88 = $5d9b09857b8fa08e$export$8837f4fc672e936d.reduce(function (accumulator, metric) {
  return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, metric.key, metric));
}, {});
var $5d9b09857b8fa08e$var$selectableMetrics = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (metric) {
  return (metric.inSummary || metric.inAnalyticsReport) && metric.category && !metric.deprecated;
});
var $5d9b09857b8fa08e$var$categoriesObj = $5d9b09857b8fa08e$export$2c76aca27257bcfa.reduce(function (accumulator, current) {
  accumulator[current] = [];
  return accumulator;
}, {});
var $5d9b09857b8fa08e$var$categorizedMetrics = $5d9b09857b8fa08e$var$selectableMetrics.reduce(function (accumulator, current) {
  accumulator[current.category].push(current);
  return accumulator;
}, $5d9b09857b8fa08e$var$categoriesObj);
var $5d9b09857b8fa08e$export$24fdeceee7dce9f = $5d9b09857b8fa08e$export$2c76aca27257bcfa.map(function (category) {
  return {
    category: category,
    metrics: $5d9b09857b8fa08e$var$categorizedMetrics[category].sort(function (a, b) {
      return a.label.localeCompare(b.label);
    })
  }; //Sorts each metric alphabetically by label
});

var $5d9b09857b8fa08e$export$316876556a26de9d = {
  inbox_folder_rate: {
    label: 'Inbox Folder Rate Industry Benchmark',
    helpText: 'When on, inbox folder rate benchmark data for industry and mailbox provider selected below will display on graph.'
  }
};
var $5d9b09857b8fa08e$export$224b14d28c9ae256 = {
  number: {
    label: 'Count',
    yAxisFormatter: $2cb2128e0b9e1f2c$export$f5dd818bff069720
  },
  percent: {
    label: 'Percent',
    yAxisFormatter: $0a59e1cff196aa1f$export$f46f3370c2c30550
  },
  milliseconds: {
    label: 'Time',
    yAxisFormatter: $c66c7baffc1c0dfc$export$5daf09ba04077ce8
  },
  bytes: {
    label: 'Size, in Bytes',
    yAxisFormatter: $2b426f67b59e8726$export$e1a3971de07c83b5
  }
};
var $e5bb4e3e907c6528$exports = {};
$parcel$export($e5bb4e3e907c6528$exports, "getRelativeDates", function () {
  return $e5bb4e3e907c6528$export$f1b9e31b5813ebf9;
});
var $ffeb066de5f0e94c$exports = {};
$parcel$export($ffeb066de5f0e94c$exports, "deprecatedParseMomentInput", function () {
  return $ffeb066de5f0e94c$export$957d5bfa8d72d081;
});
function $ffeb066de5f0e94c$export$957d5bfa8d72d081(momentInput) {
  var returnInsecureMomentInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var momentInstance = $parcel$interopDefault($6g9id$moment)(momentInput);
  if (returnInsecureMomentInstance) return momentInstance;
  return momentInstance.format();
}
/**
 * momentInsecure
 *
 * @deprecated
 *
 * */
$ffeb066de5f0e94c$export$957d5bfa8d72d081.momentInsecure = $parcel$interopDefault($6g9id$moment);
var $c20d8213d2b3df88$exports = {};
$parcel$export($c20d8213d2b3df88$exports, "roundBoundaries", function () {
  return $c20d8213d2b3df88$export$ee8b0c192023c3fd;
});
var $a9d112f3d0637294$exports = {};
$parcel$export($a9d112f3d0637294$exports, "getPrecision", function () {
  return $a9d112f3d0637294$export$e0c74b50bbd10f68;
});
var $5c580aeb1df105e0$exports = {};
$parcel$export($5c580aeb1df105e0$exports, "dateFormat", function () {
  return $5c580aeb1df105e0$export$4e4cb19dd88cd821;
});
$parcel$export($5c580aeb1df105e0$exports, "dateFormatWithComma", function () {
  return $5c580aeb1df105e0$export$31aff849042d002b;
});
$parcel$export($5c580aeb1df105e0$exports, "dateFormatWithoutYear", function () {
  return $5c580aeb1df105e0$export$62d471975ca764de;
});
$parcel$export($5c580aeb1df105e0$exports, "timeFormat", function () {
  return $5c580aeb1df105e0$export$94f4d87fad5dcf9a;
});
$parcel$export($5c580aeb1df105e0$exports, "UTC_TYPEAHEAD_OPTION", function () {
  return $5c580aeb1df105e0$export$e608a70d30657848;
});
$parcel$export($5c580aeb1df105e0$exports, "FORMATS", function () {
  return $5c580aeb1df105e0$export$e9c4b7b466aa8274;
});
$parcel$export($5c580aeb1df105e0$exports, "METRICS_PRECISION_MAP", function () {
  return $5c580aeb1df105e0$export$79c65e616cfb46c4;
});
var $5c580aeb1df105e0$export$4e4cb19dd88cd821 = 'MMM D YYYY';
var $5c580aeb1df105e0$export$31aff849042d002b = 'MMM D, YYYY';
var $5c580aeb1df105e0$export$62d471975ca764de = 'MMM D';
var $5c580aeb1df105e0$export$94f4d87fad5dcf9a = 'h:mma'; // <option> data structure for the UTC timezone
var $5c580aeb1df105e0$export$e608a70d30657848 = {
  value: 'Etc/UTC',
  label: 'UTC'
};
var $5c580aeb1df105e0$export$e9c4b7b466aa8274 = {
  /** @deprecated */MOMENT: {
    SHORT_DATE: 'YYYY-MM-DD',
    TIME: $5c580aeb1df105e0$export$94f4d87fad5dcf9a,
    LONG_DATETIME_ALT: 'MMM DD, YYYY [at] h:mma',
    INPUT_DATES: ['YYYY-MM-DD'],
    INPUT_TIMES: ['h:mma', 'H:mm', 'H:mma'],
    INPUT_DATETIMES: ['YYYY-MM-DD h:mma', 'YYYY-MM-DD H:mm', 'YYYY-MM-DD H:mma'],
    DATE_FORMAT: $5c580aeb1df105e0$export$4e4cb19dd88cd821,
    DATE_FORMAT_WITH_COMMA: $5c580aeb1df105e0$export$31aff849042d002b,
    DATE_FORMAT_WITHOUT_YEAR: $5c580aeb1df105e0$export$62d471975ca764de
  },
  DATE_FNS: {
    SHORT_DATE: 'yyyy-MM-dd',
    TIME: 'h:mmaaa',
    LONG_DATETIME_ALT: "MMM dd, yyyy 'at' h:mmaaa",
    DATE_FORMAT: 'MMM d yyyy',
    DATE_FORMAT_WITH_COMMA: 'MMM d, yyyy',
    DATE_FORMAT_WITHOUT_YEAR: 'MMM d',
    ISO8601: "yyyy-MM-dd'T'HH:mm:ssX",
    ISO8601_OFFSET: "yyyy-MM-dd'T'HH:mm:ssxxx",
    API_DATE_FORMAT: "yyyy-MM-dd'T'HH:mm",
    DATE: 'MMM do',
    DATETIME_WITH_YEAR: 'MMM do yyyy h:mma',
    DATETIME_WITHOUT_YEAR: 'MMM d, h:mmaaa',
    LONG_DATETIME: "MMM do yyyy h:mmaaaaa'm'",
    //date-fns //Bug with date-fns. token "a" not outputing lowercase
    LONG_DATETIME_WITH_COMMA: 'MMM d yyyy, h:mmaaa'
  }
};
var $5c580aeb1df105e0$export$79c65e616cfb46c4 = [{
  time: 480,
  value: '1min',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'ha',
  outputFormat: 'haaa'
}, {
  time: 14400,
  value: 'hour',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'ha',
  outputFormat: 'haaa'
}, {
  time: 47520,
  value: 'day',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'MMM Do',
  outputFormat: 'MMM do'
}, {
  time: 273600,
  value: 'week',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'MMM Do',
  outputFormat: 'MMM do'
}, {
  time: Infinity,
  value: 'month',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'MMM YY',
  outputFormat: 'MMM yy'
}];
function $a9d112f3d0637294$export$e0c74b50bbd10f68(_ref27) {
  var from = _ref27.from,
    _ref27$to = _ref27.to,
    to = _ref27$to === void 0 ? $6g9id$datefns.formatISO(new Date()) : _ref27$to;
  var fromDate = $6g9id$datefns.parseISO(from);
  var toDate = $6g9id$datefns.parseISO(to);
  var diff = $6g9id$datefns.differenceInMinutes(toDate, fromDate);
  return $5c580aeb1df105e0$export$79c65e616cfb46c4.find(function (_ref28) {
    var time = _ref28.time;
    return diff <= time;
  }).value;
}
/**
 * useMomentInput
 *
 * @param { Object } precision
 * @param { import('moment').MomentInput } precision.from - moment input
 * @param { import('moment').MomentInput } [precision.to=new Date()] - moment input
 * @returns { string } - precision formatted date
 * @deprecated
 */
$a9d112f3d0637294$export$e0c74b50bbd10f68.useMomentInput = function useMomentInput(_ref29) {
  var to = _ref29.to,
    from = _ref29.from;
  return $a9d112f3d0637294$export$e0c74b50bbd10f68({
    from: $ffeb066de5f0e94c$export$957d5bfa8d72d081(from),
    to: $ffeb066de5f0e94c$export$957d5bfa8d72d081(to)
  });
};

/**
 * @typedef {'minutes' | 'day' | 'hour'} Precision
 */ /**
    * getPrecisionDateFns
    *
    * @param { Precision } precision
    * @param { 'start' | 'end' } starOrEnd
    * @returns { (date: Date | number, year: number) => Date } - start/end of (precision) function
    */
var $c20d8213d2b3df88$var$getPrecisionDateFns = function $c20d8213d2b3df88$var$getPrecisionDateFns(precision, starOrEnd) {
  var map = {
    day: {
      start: $6g9id$datefns.startOfDay,
      end: $6g9id$datefns.endOfDay
    },
    minutes: {
      start: $6g9id$datefns.startOfMinute,
      end: $6g9id$datefns.endOfMinute
    },
    hour: {
      start: $6g9id$datefns.startOfHour,
      end: $6g9id$datefns.endOfHour
    }
  };
  return map[precision][starOrEnd];
};
/**
 * getValueDateFnsByPrecision
 *
 * @param { Precision } precision
 * @returns { (date: Date | number) => number } - get value of (precision) function
 */
var $c20d8213d2b3df88$var$getValueDateFnsByPrecision = function $c20d8213d2b3df88$var$getValueDateFnsByPrecision(precision) {
  var mapPrecision = {
    minutes: $6g9id$datefns.getMinutes,
    day: $6g9id$datefns.getDate,
    hour: $6g9id$datefns.getHours
  };
  return mapPrecision[precision];
};
function $c20d8213d2b3df88$export$ee8b0c192023c3fd(_ref30) {
  var from = _ref30.from,
    to = _ref30.to,
    _ref30$now = _ref30.now,
    now = _ref30$now === void 0 ? new Date() : _ref30$now,
    defaultPrecision = _ref30.precision;
  var fromDate = $6g9id$datefns.parseISO(from);
  var toDate = $6g9id$datefns.parseISO(to);
  var toDateOriginal = $6g9id$datefns.parseISO(to);
  var precision = defaultPrecision || $a9d112f3d0637294$export$e0c74b50bbd10f68({
    from: from,
    to: to
  });
  var precisionNormalized = $c20d8213d2b3df88$var$normalizePrecision(precision); // extract rounding interval from precision query param value
  var roundInt = precisionNormalized === 'minutes' ? parseInt(precision.replace('min', '')) : 1;
  fromDate = $c20d8213d2b3df88$var$floorDate(fromDate, roundInt, precisionNormalized); // if we're only at a minute precision, don't round up to the next minute
  var isToSameAsNow = Math.abs($6g9id$datefns.differenceInMinutes(now, toDateOriginal)) < 1;
  if (precision !== '1min' && !isToSameAsNow) toDate = $c20d8213d2b3df88$var$ceilDate(toDate, roundInt, precisionNormalized);
  return {
    to: toDate,
    from: fromDate
  };
}
function $c20d8213d2b3df88$var$normalizePrecision(precision) {
  if (precision.includes('min')) return 'minutes';
  if (['day', 'week', 'month'].includes(precision)) return 'day';
  return 'hour';
}
/**
 * Rounds up date to precision and interval
 *
 * @param { Date } date
 * @param { number } [roundInt=1]
 * @param { Precision } [precision='minutes']
 * @returns { Date }
 */
function $c20d8213d2b3df88$var$ceilDate(date) {
  var roundInt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'minutes';
  var normalizedRoundInt = isNaN(roundInt) ? 1 : roundInt;
  var value = $c20d8213d2b3df88$var$getValueDateFnsByPrecision(precision)(date);
  var roundedValue = Math.ceil(value / normalizedRoundInt) * normalizedRoundInt;
  var dateRounded = $c20d8213d2b3df88$var$setValueByPrecision(date, precision, roundedValue);
  return $c20d8213d2b3df88$var$getPrecisionDateFns(precision, 'end')(dateRounded);
}
/**
 * Rounds down date to precision and interval
 *
 * @param { Date } date
 * @param { number } [roundInt=1]
 * @param { Precision } [precision='minutes']
 * @returns { Date }
 */
function $c20d8213d2b3df88$var$floorDate(date) {
  var roundInt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'minutes';
  var normalizedRoundInt = isNaN(roundInt) ? 1 : roundInt;
  var value = $c20d8213d2b3df88$var$getValueDateFnsByPrecision(precision)(date);
  var roundedValue = Math.floor(value / normalizedRoundInt) * normalizedRoundInt;
  var dateRounded = $c20d8213d2b3df88$var$setValueByPrecision(date, precision, roundedValue);
  return $c20d8213d2b3df88$var$getPrecisionDateFns(precision, 'start')(dateRounded);
}
var $c20d8213d2b3df88$var$setValueByPrecision = function $c20d8213d2b3df88$var$setValueByPrecision(date, precision, value) {
  var map = {
    minutes: $6g9id$datefns.setMinutes,
    hour: $6g9id$datefns.setHours,
    day: $6g9id$datefns.setDate
  };
  return map[precision](date, value);
};
/**
 * useMomentInput
 *
 * @param { Object } options
 * @param { import('moment').MomentInput } options.from The beginning of the user's desired date range for a report.
 * @param { import('moment').MomentInput } options.to The end of the user's desired date range for a report.
 * @param { import('moment').MomentInput } [options.now=new Date()] The current date.
 * @param { Precision } options.precision The precision of returned timeseries data
 *
 * @returns {{to: Date, from: Date }}
 * @deprecated
 */
$c20d8213d2b3df88$export$ee8b0c192023c3fd.useMomentInput = function useMomentInput(_ref31) {
  var from = _ref31.from,
    to = _ref31.to,
    now = _ref31.now,
    precision = _ref31.precision;
  var rounded = $c20d8213d2b3df88$export$ee8b0c192023c3fd({
    from: $ffeb066de5f0e94c$export$957d5bfa8d72d081(from),
    to: $ffeb066de5f0e94c$export$957d5bfa8d72d081(to),
    now: now ? $ffeb066de5f0e94c$export$957d5bfa8d72d081(now, true).toDate() : undefined,
    precision: precision
  });
  return {
    from: $ffeb066de5f0e94c$export$957d5bfa8d72d081(rounded.from, true),
    to: $ffeb066de5f0e94c$export$957d5bfa8d72d081(rounded.to, true)
  };
};
function $e5bb4e3e907c6528$export$f1b9e31b5813ebf9(range) {
  var _ref32 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref32$now = _ref32.now,
    now = _ref32$now === void 0 ? new Date() : _ref32$now,
    _ref32$roundToPrecisi = _ref32.roundToPrecision,
    roundToPrecision = _ref32$roundToPrecisi === void 0 ? true : _ref32$roundToPrecisi,
    precision = _ref32.precision;
  var preciseFrom;
  switch (range) {
    case 'hour':
      preciseFrom = $6g9id$datefns.subHours(now, 1);
      break;
    case 'day':
      preciseFrom = $6g9id$datefns.subDays(now, 1);
      break;
    case '7days':
    case '10days':
    case '14days':
    case '30days':
    case '90days':
      {
        var numberOfDays = parseInt(range.replace('days', ''));
        preciseFrom = $6g9id$datefns.subDays(now, numberOfDays);
        break;
      }
    case 'custom':
      return {
        relativeRange: range
      };
    default:
      if (range) throw new Error("Tried to calculate a relative date range with an invalid range value: ".concat(range));
      return {};
  }
  if (roundToPrecision) {
    var _$c20d8213d2b3df88$ex = $c20d8213d2b3df88$export$ee8b0c192023c3fd({
        from: $6g9id$datefns.formatISO(preciseFrom),
        to: $6g9id$datefns.formatISO(now),
        precision: precision
      }),
      to = _$c20d8213d2b3df88$ex.to,
      from = _$c20d8213d2b3df88$ex.from;
    return {
      to: to,
      from: from,
      relativeRange: range
    };
  }
  return {
    to: now,
    from: preciseFrom,
    relativeRange: range
  };
}
/**
 * useMomentInput
 *
 * @param { Range } range
 * @param { Object } options
 * @param { import('moment').MomentInput } options.now - Date object
 * @param { Boolean } [options.roundToPrecision=true] - round to precision
 * @param { 'minutes' | 'day' | 'hour' } options.precision
 * @return {{ to: Date, from: Date, relativeRange: Range }}
 * @deprecated
 */
$e5bb4e3e907c6528$export$f1b9e31b5813ebf9.useMomentInput = function useMomentInput(range) {
  var _ref33 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    now = _ref33.now,
    roundToPrecision = _ref33.roundToPrecision,
    precision = _ref33.precision;
  return $e5bb4e3e907c6528$export$f1b9e31b5813ebf9(range, {
    now: now ? $ffeb066de5f0e94c$export$957d5bfa8d72d081(now, true).toDate() : undefined,
    roundToPrecision: roundToPrecision,
    precision: precision
  });
};
var $4b8fbdb93c67cb40$exports = {};
$parcel$export($4b8fbdb93c67cb40$exports, "relativeDateOptions", function () {
  return $4b8fbdb93c67cb40$export$225f4fa7f67b3515;
});
var $4b8fbdb93c67cb40$export$225f4fa7f67b3515 = [{
  value: 'hour',
  label: 'Last Hour'
}, {
  value: 'day',
  label: 'Last 24 Hours'
}, {
  value: '7days',
  label: 'Last 7 Days'
}, {
  value: '10days',
  label: 'Last 10 Days'
}, {
  value: '14days',
  label: 'Last 14 Days'
}, {
  value: '30days',
  label: 'Last 30 Days'
}, {
  value: '90days',
  label: 'Last 90 Days'
}, {
  value: 'custom',
  label: 'Custom'
}];
var $6b7f54a703e794aa$exports = {};
$parcel$export($6b7f54a703e794aa$exports, "mapFiltersToComparators", function () {
  return $6b7f54a703e794aa$export$d988918bf7c0fb58;
});
function $6b7f54a703e794aa$export$d988918bf7c0fb58(filters) {
  var mappedFilters = filters.reduce(function (acc, _ref34) {
    var value = _ref34.value,
      type = _ref34.type,
      id = _ref34.id;
    var filterKey = $5d9b09857b8fa08e$export$e143335c1543628[type];
    acc[filterKey] = acc[filterKey] || {
      eq: []
    };
    acc[filterKey].eq.push(filterKey === 'subaccounts' ? id : value);
    return acc;
  }, {});
  if ($parcel$interopDefault($6g9id$lodash).isEmpty(mappedFilters)) return [];
  return [{
    AND: mappedFilters
  }];
}
function $dfd4d1c1e3b52230$export$20afc3e1fe7bfc7b(query) {
  if (!query) return {};
  var _$parcel$interopDefau = $parcel$interopDefault($6g9id$qs).parse(query, {
      ignoreQueryPrefix: true,
      arrayLimit: $5d9b09857b8fa08e$export$8837f4fc672e936d.length
    }),
    from = _$parcel$interopDefau.from,
    to = _$parcel$interopDefau.to,
    _$parcel$interopDefau2 = _$parcel$interopDefau.range,
    range = _$parcel$interopDefau2 === void 0 ? '7days' : _$parcel$interopDefau2,
    metrics = _$parcel$interopDefau.metrics,
    timezone = _$parcel$interopDefau.timezone,
    _$parcel$interopDefau3 = _$parcel$interopDefau.precision,
    precision = _$parcel$interopDefau3 === void 0 ? 'hour' : _$parcel$interopDefau3,
    _$parcel$interopDefau4 = _$parcel$interopDefau.filters,
    filters = _$parcel$interopDefau4 === void 0 ? [] : _$parcel$interopDefau4,
    query_filters = _$parcel$interopDefau.query_filters,
    _$parcel$interopDefau5 = _$parcel$interopDefau.comparisons,
    comparisons = _$parcel$interopDefau5 === void 0 ? [] : _$parcel$interopDefau5,
    report = _$parcel$interopDefau.report,
    industryBenchmarkMetric = _$parcel$interopDefau.industryBenchmarkMetric,
    industryBenchmarkFilters = _$parcel$interopDefau.industryBenchmarkFilters,
    group_by = _$parcel$interopDefau.group_by,
    includePrefetched = _$parcel$interopDefau.includePrefetched;
  /**
  * Note: Is this the way we want to reset values? The reason we run into stickyness
  * issues is that this object isn't initialized and we add to it (and we don't really
  * add falsy values) which would unset this
  *  */
  var ret = {
    groupBy: undefined
  };
  if (report) ret.report = report;
  if (['true', 'false'].includes(includePrefetched)) ret.includePrefetched = JSON.parse(includePrefetched);
  if (group_by) ret.groupBy = group_by;
  if (query_filters) try {
    ret.filters = JSON.parse(decodeURI(query_filters));
  } catch (_unused) {
    ret.filters = [];
  } else {
    var filtersList = (typeof filters === 'string' ? [filters] : filters).map(function (filter) {
      var parts = filter.split(':');
      var type = parts.shift();
      var value;
      var id; // Subaccount filters include 3 parts
      // 'Subaccount:1234 (ID 554):554' -> { type: 'Subaccount', value: '1234 (ID 554)', id: '554' }
      if (type === 'Subaccount') {
        id = parts.pop();
        value = parts.join(':');
      } else value = parts.join(':');
      return {
        value: value,
        type: type,
        id: id
      };
    });
    ret.filters = $6b7f54a703e794aa$export$d988918bf7c0fb58(filtersList);
  }
  if (comparisons) ret.comparisons = comparisons;
  if (metrics) {
    ret.metrics = typeof metrics === 'string' ? [metrics] : metrics; // Maps approx to non approx version of the metric
    ret.metrics = ret.metrics.map(function (metric) {
      return metric.replace(/_approx$/, '');
    });
  }
  var fromTime = new Date(from);
  var toTime = new Date(to);
  if (from && !isNaN(fromTime)) ret.from = fromTime;
  if (to && !isNaN(toTime)) ret.to = toTime;
  if (range) {
    var invalidRange = !$parcel$interopDefault($6g9id$lodash).find($4b8fbdb93c67cb40$export$225f4fa7f67b3515, ['value', range]);
    var effectiveRange = invalidRange ? 'day' : range;
    ret = _objectSpread(_objectSpread({}, ret), $e5bb4e3e907c6528$export$f1b9e31b5813ebf9(effectiveRange));
  }
  if (precision) ret.precision = precision;
  if (timezone) ret.timezone = timezone;
  if (industryBenchmarkMetric) {
    ret.industryBenchmarkMetric = industryBenchmarkMetric;
    if (industryBenchmarkFilters) try {
      ret.industryBenchmarkFilters = JSON.parse(decodeURI(industryBenchmarkFilters));
    } catch (_unused2) {
      ret.industryBenchmarkFilters = {
        industryCategory: 'all',
        mailboxProvider: 'all'
      };
    }
  } // filters are used in pages to dispatch updates to Redux store
  return ret;
}
var $99eab608798c9fd5$exports = {};
$parcel$export($99eab608798c9fd5$exports, "getComputeKeysOrMainKeyFromMetrics", function () {
  return $99eab608798c9fd5$export$cf1eed1af51015f3;
});
function $99eab608798c9fd5$export$cf1eed1af51015f3() {
  var metrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var flattened = $parcel$interopDefault($6g9id$lodash).flatMap(metrics, function (_ref35) {
    var key = _ref35.key,
      computeKeys = _ref35.computeKeys;
    return computeKeys ? computeKeys : key;
  });
  return $parcel$interopDefault($6g9id$lodash).uniq(flattened);
}
var $71919945c92dd64b$exports = {};
$parcel$export($71919945c92dd64b$exports, "getDelimiter", function () {
  return $71919945c92dd64b$export$504b89157ac2359a;
});
var $9d4fd50d8c112975$exports = {};
$parcel$export($9d4fd50d8c112975$exports, "DELIMITERS", function () {
  return $9d4fd50d8c112975$export$dab292c7293b69ae;
});
$parcel$export($9d4fd50d8c112975$exports, "API_DATE_FORMAT", function () {
  return $9d4fd50d8c112975$export$58eacdd7158b2a77;
});
$parcel$export($9d4fd50d8c112975$exports, "DEFAULT_UNIT", function () {
  return $9d4fd50d8c112975$export$f4a68c7bf4f6b7a0;
});
var $9d4fd50d8c112975$export$dab292c7293b69ae = ',;:+~`!@#$%^*()-={}[]"\'<>?./|\\'.split('');
var $9d4fd50d8c112975$export$58eacdd7158b2a77 = "yyyy-MM-dd'T'HH:mm";
var $9d4fd50d8c112975$export$f4a68c7bf4f6b7a0 = 'number';
function $71919945c92dd64b$export$504b89157ac2359a() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var uniques = $parcel$interopDefault($6g9id$lodash).uniq(filters.map(function (f) {
    return f.value;
  }).join(''));
  return $parcel$interopDefault($6g9id$lodash).difference($9d4fd50d8c112975$export$dab292c7293b69ae, uniques).shift();
}
var $b52b70c8974e8836$exports = {};
$parcel$export($b52b70c8974e8836$exports, "getMetricsFromKeys", function () {
  return $b52b70c8974e8836$export$a19d43838000e780;
});
function $b52b70c8974e8836$export$a19d43838000e780() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var metricsColors = $5d9b09857b8fa08e$export$c3f418cdae11e815;
  return keys.reduce(function (acc, metric) {
    // Find the metric object in both list (metrics and nonPrefetchedMetrics)
    // nonPrefetched metrics it's a separated object to avoid duplicated metrics
    var metricKey = typeof metric === 'string' ? metric : metric.key;
    var found = [].concat($5d9b09857b8fa08e$export$d334702e3b05c761, $5d9b09857b8fa08e$export$8837f4fc672e936d).find(function (M) {
      return M.key === metricKey;
    });
    if (!found) return acc;
    return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, found), {}, {
      name: found.key,
      stroke: metricsColors[acc.length % metricsColors.length]
    })]);
  }, []);
}
var $da81e92cad558768$exports = {};
$parcel$export($da81e92cad558768$exports, "getUniqueUnits", function () {
  return $da81e92cad558768$export$978f0ad76a6e0201;
});
function $da81e92cad558768$export$978f0ad76a6e0201(metrics) {
  return $parcel$interopDefault($6g9id$lodash).uniq(metrics.map(function (_ref36) {
    var _ref36$unit = _ref36.unit,
      unit = _ref36$unit === void 0 ? $9d4fd50d8c112975$export$f4a68c7bf4f6b7a0 : _ref36$unit;
    return unit;
  }));
}
var $03252e58fa9586fa$exports = {};
$parcel$export($03252e58fa9586fa$exports, "toQueryFromOptions", function () {
  return $03252e58fa9586fa$export$fdd5ec6582c9d39c;
});
function $03252e58fa9586fa$export$fdd5ec6582c9d39c(_ref37) {
  var from = _ref37.from,
    to = _ref37.to,
    timezone = _ref37.timezone,
    precision = _ref37.precision,
    metrics = _ref37.metrics,
    _ref37$filters = _ref37.filters,
    filters = _ref37$filters === void 0 ? [] : _ref37$filters,
    _ref37$match = _ref37.match,
    match = _ref37$match === void 0 ? '' : _ref37$match,
    limit = _ref37.limit;
  var apiMetricsKeys = $99eab608798c9fd5$export$cf1eed1af51015f3(metrics);
  var delimiter = $71919945c92dd64b$export$504b89157ac2359a(filters);
  var options = {
    metrics: apiMetricsKeys.join(delimiter),
    from: from ? $6g9id$datefnstz.formatInTimeZone(new Date(from), timezone, $5c580aeb1df105e0$export$e9c4b7b466aa8274.DATE_FNS.API_DATE_FORMAT) : undefined,
    to: to ? $6g9id$datefnstz.formatInTimeZone(new Date(to), timezone, $5c580aeb1df105e0$export$e9c4b7b466aa8274.DATE_FNS.API_DATE_FORMAT) : undefined,
    delimiter: delimiter,
    timezone: timezone,
    precision: precision
  };
  var dehydratedFilters = $7cdedcf0446b0cfd$export$caba4a301a9efc9e(filters);
  options.query_filters = filters.length ? JSON.stringify({
    groupings: dehydratedFilters
  }) : undefined;
  if (match.length > 0) options.match = match;
  if (limit) options.limit = limit;
  return options;
}
$parcel$exportWildcard(module.exports, $76c5e6d5f2354573$exports);
$parcel$exportWildcard(module.exports, $7cdedcf0446b0cfd$exports);
$parcel$exportWildcard(module.exports, $dfd4d1c1e3b52230$exports);
$parcel$exportWildcard(module.exports, $99eab608798c9fd5$exports);
$parcel$exportWildcard(module.exports, $71919945c92dd64b$exports);
$parcel$exportWildcard(module.exports, $b52b70c8974e8836$exports);
$parcel$exportWildcard(module.exports, $da81e92cad558768$exports);
$parcel$exportWildcard(module.exports, $6b7f54a703e794aa$exports);
$parcel$exportWildcard(module.exports, $03252e58fa9586fa$exports);